import {Component, inject, OnInit, signal, WritableSignal} from '@angular/core';
import {ActivatedRoute, RouterOutlet} from '@angular/router';
import {CommonModule} from '@angular/common';
import {Menu} from '../pages/menu/menu';
import {AuthService} from '../authentication/auth-service';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [CommonModule, RouterOutlet, Menu],
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit {
  protected authService: AuthService = inject(AuthService);
  private readonly activeRoute: ActivatedRoute = inject(ActivatedRoute);
  protected showMenu: WritableSignal<boolean> = signal(false);

  constructor() {
  }

  ngOnInit(): void {
    this.activeRoute.queryParams.subscribe(params => {
      console.log('[DynamicFormComponent] Params:', params);
      if (params['_showMenu']) {
        this.showMenu.set(true);
      } else {
        this.showMenu.set(false);
      }
    })
  }


  protected get isAdmin() {
    return this.authService.userHasRole('insurance_company');
  }
}
